module.exports = __webpack_public_path__ + "static/media/2025_hintergrund_hoch.65866d76.jpg";